import type { CandidateStage } from "./candidateShortlist";

/** Закрытый просмотр новой воронки до завершения пилота. */
export const CANDIDATE_PIPELINE_PREVIEW_USER_ID = 100;

export function canViewCandidatePipelinePreview(
  user:
    | { id: number; role: string; impersonatedBy?: { id: number } | null }
    | null
    | undefined
): boolean {
  return (
    user?.id === CANDIDATE_PIPELINE_PREVIEW_USER_ID &&
    user.role === "owner" &&
    !user.impersonatedBy
  );
}

/** Новые этапы пока доступны для ручного назначения только в закрытом просмотре. */
export const CANDIDATE_PIPELINE_PREVIEW_STAGES: readonly CandidateStage[] = [
  "second_interview",
  "test_assignment",
  "shortlisted",
];
